import React from 'react';
import style from './UpgradePrompt.module.css';
import PrimaryButton from '../PrimaryButton/PrimaryButton';

const UpgradePrompt = ({ heading, description, onUpgrade }) => {
  return (
    <div className={style.UpgradePromptContainer}>
      <div className={style.UpgradePromptContent}>
        {heading && <h2 className={style.Heading}>{heading}</h2>}
        {description && <p className={style.Description}>{description}</p>}
        <PrimaryButton text="Upgrade Now" click={onUpgrade} />
      </div>
    </div>
  );
};

export default UpgradePrompt;
